export var ACTION;
(function (ACTION) {
    ACTION["ACCOUNT_DETAILS"] = "ACCOUNT_DETAILS";
    ACTION["PROFILE"] = "PROFILE";
    ACTION["BACK_BUTTON"] = "BACK_BUTTON";
    ACTION["NEED_HELP"] = "NEED_HELP";
    ACTION["EDIT_DETAILS"] = "EDIT_DETAILS";
    ACTION["LOGIN_ACTION"] = "LOGIN_ACTION";
    ACTION["RE_LOGIN_ACTION"] = "RE_LOGIN_ACTION";
    ACTION["CLOSE_MODAL"] = "CLOSE_MODAL";
    ACTION["CLOSE_OTP_MODAL"] = "CLOSE_OTP_MODAL";
})(ACTION || (ACTION = {}));
